module.exports = __webpack_public_path__ + "static/gegeqian-51cef567b7cb40becee85b1f0362d75a.jpg";